/**
 * Created by lihanying on 2017/6/23.
 */

import React from 'react'
import Loader from '../../assert/images/loader.svg'

const LoaderView = () => {
  return (
    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}>
      <img src={Loader} alt="Loader" />
      <p style={{ color: '#0078D7' }}>正在登录...</p>
    </div>
  )
}

export default LoaderView


// WEBPACK FOOTER //
// ./src/components/Loader/index.js